<template>
  <portal to="modal">
    <div
      class="complaint_modal modal cookies_configurator_modal"
      v-if="$store.state.main.cookies_configurator_modal"
    >
      <div class="phone_modal__overlay bg-overlay" @click="close_modal"></div>
      <div
        class="complaint_modal__inner bg-white"
        :class="{ mob_100: windowWidth <= 767 }"
      >
        <div class="complaint_modal__ttl_wrapper flex j_sb a_center">
          <span class="f-24 bold uppercase f-light-purple">{{
            $fn.tr("Data Preferences")
          }}</span>

          <div class="complaint_modal__x_btn pointer" @click="close_modal()">
            <svg
              id="Group_4238"
              data-name="Group 4238"
              xmlns="http://www.w3.org/2000/svg"
              width="16.971"
              height="16.971"
              viewBox="0 0 16.971 16.971"
            >
              <rect
                id="Rectangle_543"
                data-name="Rectangle 543"
                width="20"
                height="4"
                rx="2"
                transform="translate(2.828 0) rotate(45)"
              />
              <rect
                id="Rectangle_1219"
                data-name="Rectangle 1219"
                width="20"
                height="4"
                rx="2"
                transform="translate(16.971 2.829) rotate(135)"
              />
            </svg>
          </div>
        </div>
        <div class="cookies_configurator_modal__preferences flex column">
          <p class="regular cookies_configurator_modal__instructions">
            {{
              _.get(
                $store.state.main.indx.widgets,
                "data_preferences_text.text.teaser"
              )
            }}
            <a
              target="_blank"
              :href="
                _.get(
                  $store.state.main.indx.widgets,
                  'data_preferences_text.text.url'
                )
              "
              class="f-cyan underline"
              >{{
                _.get(
                  $store.state.main.indx.widgets,
                  "data_preferences_text.text.title"
                )
              }}</a
            >
          </p>
          <!-- <div
            class="cookies_configurator_modal__preference flex column"
            v-for="(pref, index) in prefs"
            :key="index"
          > -->
          <div
            class="cookies_configurator_modal__preference flex column"
            v-for="(pref, index) in Object.entries(prefs)"
            :key="index"
          >
            <div
              class="cookies_configurator_modal__preference--ttl_wrapper flex j_sb a_center"
            >
              <!-- <span class="bold uppercase">{{ _.get(pref, "title") }}</span> -->
              <span class="bold uppercase">{{ _.get(pref, "1.title") }}</span>
              <el-switch
                v-if="pref[0] === 'general'"
                v-model="switchers[pref[0]]"
                active-color="#7063E9"
                :disabled="switchers[pref[0]]"
                inactive-color="#B5B5B6"
              >
              </el-switch>
              <el-switch
                v-else
                v-model="switchers[pref[0]]"
                active-color="#7063E9"
                :disabled="pref[0] == 'general'"
                inactive-color="#B5B5B6"
              >
              </el-switch>
            </div>
            <p class="regular" v-html="_.get(pref, '1.teaser')"></p>
          </div>

          <div @click="submit_cookies" class="button cookies_configurator_modal__button flex j_center a_center bg-light-purple pointer">
            <span class="bold uppercase f-white"> {{ $fn.tr('Save') }}</span>
          </div>
        </div>
      </div>
    </div>
  </portal>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
import fix_100_vh_android from "@/mixins/fix_100_vh_android";
import fn from "@/helpers/func";
export default {
  mixins: [resize_handler, fix_100_vh_android],

  data() {
    return {
      strict: true,
      switchers: [],
    };
  },
  mounted() {
    let cookieKeys = Object.keys(this.prefs);
    if (cookieKeys && cookieKeys?.length) {
      this.switchers = cookieKeys.reduce((a, b) => {
        if (b === "general") {
          a[b] = true;
        } else {
          a[b] = false;
        }

        return a
      }, {});
    }
  },
  methods: {
    close_modal() {
      document.querySelector(".modal").classList.remove("modal_active");
      setTimeout(() => {
        this.$store.state.main.cookies_configurator_modal = !this.$store.state
          .main.cookies_configurator_modal;
      }, 701);
    },
    submit_cookies() {
      let cookiesValue = Object.entries(this.switchers).filter(x => x[1]).map(x => x[0]).join(",");

      this.$cookies.set("validCookies", cookiesValue, "1m");

      this.close_modal();
      this.$store.state.main.cookies_hide = true;
    }
  },
  computed: {
    _modal() {
      return this.$store.state.main.cookies_configurator_modal;
    },
    prefs() {
      // return _.get(this.$store.state.main.indx, "terms.cookies_preferences");
      return _.get(this.$store.state.main.indx, "cookies.places");
    }
  },
  watch: {
    _modal(ns, os) {
      if (ns == true) {
        document
          .querySelector(".header-wrapper.scrolled")
          .classList.add("hide");
        setTimeout(() => {
          document
            .querySelector(".cookies_configurator_modal")
            .classList.add("modal_active");
        }, 10);
      }
      if (this.windowWidth <= 767) {
        ns == true
          ? document.querySelector("body").classList.add("modal-open")
          : document.querySelector("body").classList.remove("modal-open");
        ns == true
          ? document.querySelector("html").classList.add("modal-open")
          : document.querySelector("html").classList.remove("modal-open");
      }
    },

    focuses(ns, os) {
      console.log(ns);
    },
    $route(to, from) {
      if (this.$store.state.main.cookies_configurator_modal) {
        this.$store.state.main.cookies_configurator_modal = !this.$store.state
          .main.cookies_configurator_modal;
      }
    }
  }
};
</script>

<style lang="sass">
.cookies_configurator_modal
    z-index: 999 !important
    .complaint_modal
        &__ttl_wrapper
            margin-bottom: 33px
    &__instructions
        margin-bottom: 24px
    &__preference 
        margin-bottom: 24px
        &--ttl_wrapper 
            margin-bottom: 21px
    &__button 
        padding-top: 22px
        padding-bottom: 22px
        transition: .4s
    @media (min-width: 1024px)
        &__button 
            &:hover 
                background-color: #613DD1
            
</style>
